module.exports = __webpack_public_path__ + "static/media/furnitures.fbfbcba9.svg";